







import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { RenderPostModel } from "@/services/render/types";
import {
    ClockPostProperties,
    ClockCss,
    HourFormatEnum
} from "@/services/posts/postTypes/clock";

import { Style } from "@/services/styles/types";
import moment from "moment";
import { TimeZone } from "@/services/timeZones/types";
import { getTimeZones } from "@/services/timeZones/timeZoneService";
import { setNextItem } from "../types";
import { Getter } from "vuex-class";
import i18n from "@/i18n";

@Component
export default class ClockRender extends Vue {
    @Prop() private item!: RenderPostModel;
    @Prop() private itemStyle!: Style; // it's used only in style form preview
    @Prop() private active!: number;
    @Prop() private token!: string;
    @Getter("render/getCurrentSolutionTimezoneId") currentSolutionTimezoneId!: string;

    setNextItemTimer = 0;
    @Watch("active", { immediate: true, deep: true })
    onActiveChange(value: number) {
        if (value !== 0) {
            this.getClock();
            clearTimeout(this.setNextItemTimer);
            this.setNextItemTimer = setTimeout(
                this.setNextItem,
                this.propertiesModel.showTime * 1000
            );
        }
    }

    timeZones: TimeZone[] = [];
    // Lyfecycle
    async created() {
        this.timeZones = await getTimeZones();
        const browserLocation = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const localUtcOffset = browserLocation ? this.timeZones.find(x => x.displayName.includes(browserLocation.split("/")[1])) : null;
        this.timeZones.unshift({
            id: "localtime",
            displayName: i18n.t("posts.clock.timezones.localTime"),
            baseUtcOffset: localUtcOffset ? localUtcOffset.baseUtcOffset : moment().utcOffset.toString(),
            offset: localUtcOffset ? localUtcOffset.offset : moment().utcOffset.toString()
        } as TimeZone).toString();
        this.timeZones.unshift({
            id: "SolutionTimeZone",
            displayName: i18n.t("posts.clock.timezones.solutionTimeZone"),
            baseUtcOffset: this.currentSolutionTimezone ? this.currentSolutionTimezone.baseUtcOffset : (localUtcOffset ? localUtcOffset.baseUtcOffset : moment().utcOffset().toString()),
            offset: this.currentSolutionTimezone ? this.currentSolutionTimezone.offset : (localUtcOffset ? localUtcOffset.offset : moment().utcOffset.toString())
        } as TimeZone).toString();
        if (this.itemStyle) {
            this.getClock();
        }
    }

    destroyed() {
        clearTimeout(this.secondCounter);
    }

    secondCounter = 0;
    clock = {};

    get currentSolutionTimezone() {
        for (const timezone of this.timeZones) {
            if (timezone.id === this.currentSolutionTimezoneId) {
                return timezone;
            }
        }
    }

    getClock() {
        if (this.utcOffset.length > 0) {
            this.clock = moment().utcOffset(this.utcOffset).format("[" + this.propertiesModel.clockFormat.textOne + "]" +
                this.setHourFormat(this.propertiesModel.clockFormat.clockOptionOne) +
                "[" + this.propertiesModel.clockFormat.textTwo + "]" +
                this.setHourFormat(this.propertiesModel.clockFormat.clockOptionTwo) +
                "[" + this.propertiesModel.clockFormat.textThree + "]" +
                this.setHourFormat(this.propertiesModel.clockFormat.clockOptionThree) +
                "[" + this.propertiesModel.clockFormat.textFour + "]" +
                this.setHourFormat(this.propertiesModel.clockFormat.clockOptionFour) +
                "[" + this.propertiesModel.clockFormat.textFive + "]");
        }
        this.setSecondCounter();
    }

    get utcOffset(): string {
        var timezone = this.timeZones.find(x => x.id.toLowerCase() === this.propertiesModel.timeZone.toLowerCase());
        var result = timezone ? timezone.offset.charAt(0) !== "-" ? "+".concat(timezone.offset) : timezone.offset : "";
        return result;
    }

    setSecondCounter() {
        this.secondCounter = setTimeout(
            this.getClock, 1000
        );
    }

    get propertiesModel(): ClockPostProperties {
        return this.item.properties
            ? (this.item.properties as ClockPostProperties)
            : ({} as ClockPostProperties);
    }

    get styleModel(): ClockCss {
        return this.item.css && Object.entries(this.item.css).length > 0 && this.item.css.constructor === Object ? this.item.css as ClockCss : this.itemStyle ? this.itemStyle.css as ClockCss : {} as ClockCss;
    }

    setHourFormat(value: string) {
        if (this.propertiesModel.hourFormat === HourFormatEnum.h24 && (value === "h" || value === "hh")) {
            return value.toUpperCase();
        } else {
            return value;
        }
    }

    setNextItem() {
        clearTimeout(this.secondCounter);
        this.secondCounter = 0;

        this.$emit("setNextItem", { id: this.item.id } as setNextItem);
    }
}
